import { useMemo } from 'react';

import {
	type StarterDashboardV2PageData,
	useStarterDashboardV2PageData,
	useStarterDashboardV2PageFcm,
} from 'src/app/pages/starterDashboardV2/pageContext';
// FIXME refactor needed to not import internal logic from the shared hooks
// eslint-disable-next-line @change/sibling-module-imports
import { useShareVisualModalBody } from 'src/app/pages/starterDashboardV2/shared/hooks/useTriggerShareVisualModal/useShareVisualModal/components/ShareVisualModalBody/hooks/useShareVisualModalBody';
import type { ShareVisualImg } from 'src/app/pages/starterDashboardV2/shared/types';
import { useLocale } from 'src/app/shared/hooks/l10n';

import { useShareSocial } from '../../../ShareYourPetition/components/ShareSocial/hooks/useShareSocial';

type Context = 'starter_dashboard_grow_petition';
export type ShareVisualData = {
	buttonDisabled: boolean;
	newModuleEnabled: boolean;
	shareVisualDownloaded: boolean;
	shareVisualEnabled: boolean;
	shareVisualsState: 'loading' | 'loaded' | 'timeout';
	petition: StarterDashboardV2PageData['petition'];
	items: ShareVisualImg[];
};

type UseShareVisualReturn = ModelHookResult<
	ShareVisualData,
	{
		onShareVisualDownload: (event: React.FormEvent<HTMLFormElement>) => void;
		onShareVisualSelect: () => void;
	}
>;

export function useShareVisual(): UseShareVisualReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const {
		data: { shareVisual },
	} = useShareSocial();
	const context: Context = 'starter_dashboard_grow_petition';
	const {
		data,
		actions: { onShareVisualDownload, onShareVisualSelect },
	} = useShareVisualModalBody({ petition, context });
	const locale = useLocale();

	const { starterDashboardNewAssetsConfig } = useStarterDashboardV2PageFcm();

	const newAssetsEnabled = useMemo(() => {
		const disabled = { enabled: false } as const;
		if (!starterDashboardNewAssetsConfig) return disabled;
		if (!starterDashboardNewAssetsConfig.enabled) return disabled;
		if (!starterDashboardNewAssetsConfig.locales.includes(locale)) return disabled;

		return { enabled: true } as const;
	}, [locale, starterDashboardNewAssetsConfig]);

	return {
		data: {
			petition,
			buttonDisabled: data.disabled,
			newModuleEnabled: newAssetsEnabled.enabled,
			shareVisualDownloaded: data.shareVisualDownloaded,
			shareVisualEnabled: shareVisual.enabled,
			shareVisualsState: data.shareVisualsState,
			items: data.shareVisuals,
		},
		actions: {
			onShareVisualDownload,
			onShareVisualSelect,
		},
	};
}
